import { Component } from '@angular/core';

// This component is mainly meant to be used in Routes that act as interceptors,
// but can be used anywhere an empty component is needed.
@Component({
    selector: 'lsq-noop',
    template: ''
})
export class LsqNoopComponent {}
